import * as queryString from 'query-string';
export class Filter {
  public params: any;

  constructor(params = {}) {
    this.params = params;
  }

  toQueryString(): string {
    const TARGET = { ...this.params };
    const RESPONSE = queryString.stringify(TARGET, {
      skipEmptyString: true,
      skipNull: true,
      arrayFormat: 'bracket',
    });
    return RESPONSE;
  }

  addFilter(key: string, value: any): void {
    this.params[key] = value;
  }

  removeFilter(key: string): void {
    delete this.params[key];
  }
}
